// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import dayjs from "dayjs"
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

// let vSerachText = "";

export default function MemberListTable(props) {

  const { onSelectUserChange, disableMultiSelectMember } = props;

  const members = props.members || [];
  const selUserIDs = props.selUserIDs || [];
  const rowSelection = (disableMultiSelectMember == true ? "single" : "multiple");
  const rowMultiSelectWithClick = !(disableMultiSelectMember == true);
  const headerCheckboxSelection = !(disableMultiSelectMember == true);


  const gridData = members.map(item => {
    return {
      ...item,
      // Action: DmsCommon.ActionEnumToStr(item.ActionReq),
      // Status: item.ReadDate ? `Read version ${item.ReadVer} on ${dayjs(item.ReadDate).format(DmsCommon.SHORT_DATETIME_FORMAT)} ` : "",
      // PrevStatus: item.PrevDate ? `Read version ${item.PrevDate} on ${dayjs(item.PrevDate).format(DmsCommon.SHORT_DATETIME_FORMAT)} ` : "",
    }
  })

  // console.log("MemberListTable gridData", gridData);

  const [selUsers, setSelUsers] = useState([]);
  const [selectedUserNames, setSelectedUserNames] = useState("");

  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);

    params.api.forEachNode(function (node) {
      node.setSelected(selUserIDs.includes(node.data.UserID));
    });
  };

  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();


    let selUsers = nodes.map(item => {
      return item.data
    });

    setSelUsers(selUsers);

    // const vIDs = selUsers.map(x => x.UserID);
    // console.log("vIDs", vIDs);
    onSelectUserChange && onSelectUserChange(selUsers);

    const vNames = selUsers.map(x => x.FullName);
    setSelectedUserNames(vNames.join(", "));

  }


  const [searchText, setSearchText] = useState("");
  const handleSearchTextChange = (e) => {
    const vVal = e.target.value;
    // console.log("handleSearchTextChange", vVal);
    setSearchText(vVal);
    // vSerachText = vVal;

    // gridApi.onFilterChanged();
    gridApi.setQuickFilter(vVal);
  }

  const handleGetRowId = useCallback((params) => params.data.UserID, []);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorUserID = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.UserID, nodeB.data.UserID)
  }

  const comparatorFullname = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.FullName, nodeB.data.FullName)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Department, nodeB.data.Department)
  }

  const comparatorDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.Desc, nodeB.data.Desc)
  }

  const columnDefs = [
    { field: 'UserID', headerName: "UserID", cellStyle: cellStyle, width: 150, headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorUserID },
    { field: 'FullName', headerName: "FullName", cellStyle: cellStyle, minWidth: 100, flex: "1", comparator: comparatorFullname },
    { field: 'Department', headerName: "Department", cellStyle: cellStyle, width: 150, comparator: comparatorDept },
    { field: 'Desc', headerName: "Description", cellStyle: cellStyle, width: 150, comparator: comparatorDesc },
  ];


  return (
    <React.Fragment>

      <Box sx={{ flexGrow: 1, p: 0 }}>

        <Box sx={{ flexGrow: 1, pb: 1 }}>
          <Grid container spacing={{ xs: 1 }}  >
            <Grid item xs={4}>
              <TextField
                id="standard-member-search"
                label="Search"
                type="search"
                variant="standard"
                value={searchText}
                onChange={handleSearchTextChange}
              />
            </Grid>
            <Grid item xs={8} sx={{ maxHeight: "6em", overflow: 'auto', }}   >
              Selected({selUsers?.length || 0}): {selectedUserNames}
            </Grid>
          </Grid>
        </Box>

        <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
          <AgGridReact

            rowData={gridData}

            defaultColDef={{
              width: 100,
              resizable: true,
              sortable: true,
              suppressMovable: true,
            }}
            columnDefs={columnDefs}
            headerHeight={40}

            suppressNoRowsOverlay

            rowSelection={rowSelection}
            rowMultiSelectWithClick={rowMultiSelectWithClick}
            onSelectionChanged={onSelectionChanged}
            // isExternalFilterPresent={isExternalFilterPresent}
            // doesExternalFilterPass={doesExternalFilterPass}
            onGridReady={onGridReady}

            // getRowNodeId={(data) => data.UserID}
            getRowId={handleGetRowId}
          >
          </AgGridReact>

        </div>

      </Box>
    </React.Fragment>


  );
}

MemberListTable.propTypes = {
  members: PropTypes.array,
  selUserIDs: PropTypes.array,
  disableMultiSelectMember: PropTypes.bool,
  onSelectUserChange: PropTypes.func,
};
